import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { publishArticle } from 'action/article'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, publishText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${publishText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${publishText}ed`
    },
    title: {
      error: `There has been an issue ${publishText}ing ${title}`,
      success: `Article ${publishText}ed`
    }
  }
})

const PublishArticle = ({ publishArticle, article: { uuid, title, published: isPublished, is_draft: isDraft } }) => {
  const publishText = isPublished ? 'unpublish' : 'publish'

  const handleSubmit = () => publishArticle(uuid)

  const { decide, outcome } = generateModalText(title, publishText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(publishText)} Article`}</Button>
  )
}

PublishArticle.propTypes = {
  article: PropTypes.object,
  publishArticle: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  publishArticle: bindActionCreators(publishArticle, dispatch)
})

export default connect(null, mapDispatchToProps)(PublishArticle)
